




































































import Icon from '@/components/Icon.vue';

export default {
  name: 'Nav',
  components: {Icon}
};
